import { render, staticRenderFns } from "./goDialogMaterial.vue?vue&type=template&id=13955f8e"
import script from "./goDialogMaterial.vue?vue&type=script&lang=js"
export * from "./goDialogMaterial.vue?vue&type=script&lang=js"
import style0 from "./goDialogMaterial.vue?vue&type=style&index=0&id=13955f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports